export const mainUrl = 'https://luckymyanmar.com/api/';